type GridSize = (typeof GRID_SIZES)[number];

// グリッドヒートマップでのメッシュサイズ
const GRID_SIZES = [
  {
    label: '10m',
    value: 10,
  },
  {
    label: '125m',
    value: 125,
  },
  {
    label: '250m',
    value: 250,
  },
  {
    label: '500m',
    value: 500,
  },
  {
    label: '1km',
    value: 1000,
  },
] as const satisfies readonly { label: string; value: number }[];

export type { GridSize };
export { GRID_SIZES };
